<template>
  <div v-if="visible" class="cookie-consent-banner elevation-8">
    <v-container>
      <v-row align="center" no-gutters>
        <v-col cols="12" md="8" class="pr-md-4">
          <p class="mb-0 text-body-medium">
            Ce site utilise des témoins (cookies) analytiques et de sécurité des paiements pour améliorer votre
            expérience.
            <a href="#" class="cookie-consent-banner__link" @click.prevent="showDetails = !showDetails">
              {{ showDetails ? "Masquer les détails" : "En savoir plus" }}
            </a>
          </p>
          <v-expand-transition>
            <div v-if="showDetails" class="mt-2 text-body-medium text-medium-emphasis">
              <strong>Google Analytics</strong> (<code>_ga</code>, <code>_ga_*</code>) — mesure d'audience anonymisée,
              conservés 13&nbsp;mois.<br />
              <strong>Stripe</strong> — des témoins de sécurité peuvent être déposés uniquement lorsque vous ouvrez le
              portail de paiement sécurisé.<br />
              <span class="text-body-small">Votre consentement est valide 12&nbsp;mois et peut être retiré à tout moment.</span>
            </div>
          </v-expand-transition>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-end mt-3 mt-md-0">
          <v-btn variant="text" size="small" class="mr-2" @click="decline">Refuser</v-btn>
          <v-btn color="primary" size="small" @click="accept">Accepter</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  const STORAGE_KEY = "qwwCookieConsent";
  const EXPIRY_MS = 365 * 24 * 60 * 60 * 1000; // 12 months

  function readStoredConsent() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.accepted !== "boolean" || !parsed.timestamp) return null;
      if (Date.now() - parsed.timestamp > EXPIRY_MS) return null; // expired
      return parsed.accepted;
    } catch {
      return null;
    }
  }

  function writeConsent(accepted) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted, timestamp: Date.now() }));
  }

  export default {
    name: "CookieConsentBanner",
    emits: ["consent"],
    data() {
      return {
        visible: false,
        showDetails: false,
      };
    },
    created() {
      const stored = readStoredConsent();
      if (stored === null) {
        // No valid stored consent — show the banner.
        this.visible = true;
      } else {
        // Stored decision still valid — re-apply silently without showing the banner.
        this.$emit("consent", stored);
      }
    },
    methods: {
      accept() {
        writeConsent(true);
        this.visible = false;
        this.$emit("consent", true);
      },
      decline() {
        writeConsent(false);
        this.visible = false;
        this.$emit("consent", false);
      },
    },
  };
</script>

<style scoped>
  .cookie-consent-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1200;
    background-color: rgb(var(--v-theme-surface));
    color: rgb(var(--v-theme-on-surface));
    border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
    padding: 3px 0;
  }

  .cookie-consent-banner__link {
    white-space: nowrap;
    color: rgb(var(--v-theme-section-name));
  }
</style>
